import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsFetching } from 'store/Agents/selectors';
import isEmpty from 'lodash/isEmpty';
import Wrapper from './styled';
import EmptyAgents from './components/EmptyAgents';
import UserAgents from './components/UserAgents';
import { getUserAgents } from 'store/Agents/actions';

const Grid = ({ agents }) => {
  const isFetching = useSelector(selectIsFetching);
  const dispatch = useDispatch();
  const noAgents = isEmpty(agents) && !isFetching;

  useEffect(() => {
    dispatch(getUserAgents());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (noAgents) {
    return (
      <Wrapper>
        <EmptyAgents />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <UserAgents agents={ agents } />
    </Wrapper>
  );
};

export default Grid;
